export default {
  CIVILITY: 'civility',
  CONTACT_CIVILITY: 'contact_civility',
};
